import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/App";
import { normalizeLead } from "./leadModel";

// Normalised lead view plus the two network actions a card can take (refresh intel, convert to account).
export const useLeadCard = ({ lead, index, onIntelRefreshed }) => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [refreshedIntel, setRefreshedIntel] = useState(null);
  const [lastRefreshed, setLastRefreshed] = useState(null);
  const [isConverting, setIsConverting] = useState(false);
  const [isConverted, setIsConverted] = useState(false);
  const view = normalizeLead(lead, refreshedIntel);

  const refreshIntel = async () => {
    if (!view.company) return toast.error("Company name required to refresh intel");
    setIsRefreshing(true);
    try {
      const response = await axios.post(`${API}/search/refresh-intel`, {
        companyName: view.company,
        personName: view.name !== "Unknown" ? view.name : null,
        industry: view.industry,
      });
      setRefreshedIntel(response.data);
      setLastRefreshed(new Date().toLocaleTimeString());
      toast.success(`Intel refreshed for ${view.company}`);
      onIntelRefreshed?.(lead, index, response.data);
    } catch (error) {
      console.error("Error refreshing intel:", error);
      toast.error("Failed to refresh intel");
    } finally {
      setIsRefreshing(false);
    }
  };

  const convertToAccount = async () => {
    if (!lead.leadId) return toast.error("Save this lead first before converting to account");
    setIsConverting(true);
    try {
      const response = await axios.post(`${API}/leads/${lead.leadId}/convert-to-account`);
      setIsConverted(true);
      if (response.data.alreadyExisted) toast.info(`Account "${view.company}" already exists`);
      else toast.success(`Converted "${view.company}" to account!`);
    } catch (error) {
      console.error("Error converting to account:", error);
      toast.error("Failed to convert to account");
    } finally {
      setIsConverting(false);
    }
  };

  return { view, isRefreshing, lastRefreshed, isConverting, isConverted, refreshIntel, convertToAccount };
};
